import { expresion_adm, expresion_civil } from 'components/Admin/Inicio-Admin/Dashboard_Admin';

import { EstadosDesvinculacionValidation, IsOpcionDesvinculacionDirectivo, IsOpcionDesvinculacionUsuario, opcionesSideBar, OPCION_TITULO_PLANIFICACION_VACACIONES, ROL_DIRECTIVO_UNIDAD, ROL_DIRECTOR_TALENTOHUMANO, ROL_USUARIO, useSideBarContext, ROL_NOMINA_TH, ROL_ANALISTA_TH, ROL_ANALISTA_TH_AP, ROL_ASESOR, ROL_RECTOR, ROL_VICERRECTOR ,ROL_USUARIO_SUBROGANTE, OPCION_TITULO_ASIGNACION_PRESUPUESTO, ROL_ENCARGADO_GPE, ROL_NOMINA_TH_HE, ROL_ADMINISTRADOR, ROL_FIRMA_HORAS_EXTRAS, ROL_ANALISTA_GPE, OPCION_TITULO_MODIFICACION_PRESUPUESTO, OPCION_TITULO_HISTORIAL_MOD_PRESUPUESTO } from 'Context/SideBarContext';


import { VerificarSoloTieneContratoRegimen } from 'functions/DatosUsuarioFunctions';
import React from 'react'
import { useHistory } from 'react-router';
import { TransitionStatus } from 'react-transition-group';
import { Icono_Flecha_Regreso, UserData } from './Sidebar_Principal';
import Sidebar_Principal_Row from './Sidebar_Principal_Row';

export interface Sidebar_Principal_SubmenuNietoProps {
    state_transition: TransitionStatus,
    datos_usuario: UserData
}

export const ID_REGIMEN_CONTRATO_CIVIL = 0;
export const ID_REGIMEN_CONTRATO_LOES = 0;


const Sidebar_Principal_SubmenuNieto = (props: Sidebar_Principal_SubmenuNietoProps) => {
    const { valoressubMenuNieto, subMenuNieto, setsubMenuNieto, titulo_opcion_padre, titulo_opcion_submenuNieto, icono_opcion_padre, subMenuDatosPersonales, subMenuCuartoNivel } = useSideBarContext()
    const component_arrow_left_header = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
        <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
    </svg>

    let history = useHistory();
    const function_choice_animation_style = () => {

        const componente_salio = props.state_transition === "exited" || props.state_transition === "unmounted" || props.state_transition === "exiting"
        const timing = ".4s"

        if (props.state_transition === "entering" && subMenuNieto) {
            return {
                animation: `moveSubContainer ${timing} forwards`
            }
        }
        else if (props.state_transition === "entered") {
            return {
                transform: "translateX(0px)"
            }
        }
        else if (componente_salio && subMenuDatosPersonales) {
            return {
                animation: `moveMainContainer ${timing} forwards`
            }
        }
        else if (componente_salio && !subMenuNieto && !subMenuCuartoNivel) {
            return {
                animation: `moveSubContainer ${timing} reverse forwards`
            }
        }
        else if (componente_salio && subMenuCuartoNivel) {
            return {
                animation: `moveMainContainer ${ timing } forwards`
            }
        }

    }

    function handleClickOpcion(opciones: opcionesSideBar, redirect = false) {
        if (opciones.link) history.push(opciones.link);
    }



    function condicion_mostrar_opciones_nieto(opcion: opcionesSideBar, isplanifvacactivated: boolean, tipo_director_unidad: string, datos_usuario: UserData, titulo_opcion_padre: string) {
        const titulo_opcion_firmar_certificados = "Firmar Certificados";
        const titulo_opcion_admin_solic_certificados = "Emisión Certificados";
        const tiulo_planificacion_docente = "Planificación del personal docente";
        const titulo_opcion_cuenta_bancaria = "Registro / Actualización de Cuenta Bancaria";
        const titulo_opcion_decimos = "Acumulación / Mensualización Décimos";
        const titulo_opcion_gastos_personales = "Proyección de Gastos Personales";
        const titulo_opcion_formulario = "Formulario 107";
        const titulo_registro_marcaciones = "Registro de marcaciones";
        const titulo_opcion_firmar_accion = "Firmar Acción de Personal";
        const titulo_opcion_firmar_aprobaciones = "Validación de Solicitudes";
        const titulo_notificacion_embarazo = "Notificación de embarazo";
        const titulo_opcion_firmar_notificacion = "Notificación Embarazo";
        const titulo_registro_e_s_almuerzo = "Registro de receso/almuerzo";
        const titulo_registro_marcaciones2 = "Registro de marcaciones ";
        const titulo_registro_proyectos_institucionales = "Proyectos institucionales";
        const titulo_registro_proyectos_institucionales_autoridad = "Designación Proyectos institucionales";
        const titulo_registro_proyectos_institucionales_consultor = "Consulta Proyectos institucionales";
        const titulo_firma_documento_pago = "Firma Documento Pago";
        const PERSONALDOCENTE = "PD";
        const PERSONALADMINISTRATIVO = "PA";
        const titulo_opcion_actualizacion_de_datos = "Actualización de Datos";
        const titulo_opcion_historial_marcaciones = "Historial de marcaciones / justificaciones";
        const titulo_opcion_vacaciones = "Vacaciones";
        const titulo_opcion_horas_extras = "Horas Extras";

        var resultado: JSX.Element = (
            <div className="submenuOpcionesHeaderNieto  ">
                <div className="container_icono_Principal_Content">
                    {/* {props.icon_opcion_padre?props.icon_opcion_padre():""} */}
                </div>
                {
                    <span onClick={() => handleClickOpcion(opcion)}>
                        {opcion.tituloStyled}
                    </span>
                }
                {
                    opcion.tituloStyled === undefined &&
                    <div className=" texto_submenuOpcionesHeaderNieto" onClick={() => handleClickOpcion(opcion)}>
                        {opcion.titulo}
                    </div>
                }

            </div>
        )

        var resultadoRedirect: JSX.Element = (
            <div className="submenuOpcionesHeaderNieto  ">
                <div className="container_icono_Principal_Content">
                    {/* {props.icon_opcion_padre?props.icon_opcion_padre():""} */}
                </div>
                {
                    <span onClick={() => handleClickOpcion(opcion)}>
                        {opcion.tituloStyled}
                    </span>
                }
                {
                    opcion.tituloStyled === undefined &&
                    <a className=" texto_submenuOpcionesHeaderNieto" href={opcion.link} target="_blank">
                        {opcion.titulo}
                    </a>
                }
            </div>
        )

        if (opcion.titulo === titulo_opcion_actualizacion_de_datos) {
            { return resultadoRedirect };
        }
        else if (opcion.titulo === titulo_opcion_historial_marcaciones) {
            { return resultadoRedirect };
        }
        else if (opcion.titulo === titulo_opcion_vacaciones) {
            { return resultadoRedirect };
        }
        if (IsOpcionDesvinculacionUsuario(opcion.titulo) && opcion.rol_usuario === "USUARIO") {
            
            if (EstadosDesvinculacionValidation(opcion.titulo, datos_usuario.estadosDesvinculacion)) { return resultadoRedirect };
        }
        else if (IsOpcionDesvinculacionDirectivo(opcion.titulo) && titulo_opcion_padre === "DIRECTIVO DE UNIDAD") {
            
            return resultadoRedirect
        }
        else if (opcion.titulo === OPCION_TITULO_PLANIFICACION_VACACIONES) {
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_USUARIO) {
                if (isplanifvacactivated) return resultado

            }
            else {
                return resultado
            }

        }
        else if (opcion.titulo === titulo_registro_marcaciones) {
            if (expresion_adm(datos_usuario.regimen_usuario) && datos_usuario.roles_usuario.includes(ROL_DIRECTIVO_UNIDAD))
                return resultado
        }
        else if (opcion.titulo === titulo_opcion_firmar_certificados) {
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_DIRECTOR_TALENTOHUMANO) {

                var indice_respuesta: number = datos_usuario.roles_usuario.findIndex((value, index) => {
                    return value == ROL_DIRECTOR_TALENTOHUMANO
                })

                if (indice_respuesta != -1) {
                    return resultado
                }
            }
            else {
                return resultado
            }

        }
        else if (opcion.titulo === titulo_opcion_firmar_aprobaciones) {
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_ANALISTA_TH_AP) {

                var indice_respuesta: number = datos_usuario.roles_usuario.findIndex((value, index) => {
                    return value == ROL_ANALISTA_TH_AP
                })

                if (indice_respuesta != -1) {
                    return resultado
                }
            }
            else {
                return resultado
            }

        }
        else if (opcion.titulo === titulo_opcion_firmar_notificacion) {
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_ANALISTA_TH_AP) {

                var indice_respuesta: number = datos_usuario.roles_usuario.findIndex((value, index) => {
                    return value == ROL_ANALISTA_TH_AP
                })

                if (indice_respuesta != -1) {
                    return resultado
                }
            }
            else {
                return resultado
            }

        }
        else if (opcion.titulo === titulo_opcion_firmar_accion && opcion.rol_usuario && opcion.rol_usuario === ROL_DIRECTOR_TALENTOHUMANO) {
            if (datos_usuario.roles_usuario.find((roles) => roles === ROL_DIRECTOR_TALENTOHUMANO)) {
                return resultado
            }
        }
        else if (opcion.titulo === titulo_opcion_firmar_accion && opcion.rol_usuario && opcion.rol_usuario === ROL_ANALISTA_TH_AP) {
            if (datos_usuario.roles_usuario.find((roles) => roles === ROL_NOMINA_TH)) {
                return resultado
            }
        }
        else if (opcion.titulo === titulo_opcion_admin_solic_certificados) {
            if (!datos_usuario.roles_usuario.find((roles) => roles === ROL_DIRECTOR_TALENTOHUMANO)) {
                return resultado
            }
        }
        else if (opcion.titulo === titulo_opcion_decimos || opcion.titulo === titulo_opcion_gastos_personales || opcion.titulo === titulo_opcion_formulario) {
            if (!expresion_civil(datos_usuario.regimen_usuario)) {
                if (opcion.titulo === titulo_opcion_gastos_personales || opcion.titulo === titulo_opcion_formulario)
                    return resultadoRedirect
                else
                    return resultado
            }
                
        }
        else if (opcion.titulo === titulo_opcion_cuenta_bancaria) {
            if (!datos_usuario.soloTieneContratoESPOLTECH) {
                return resultadoRedirect
            }
        }
        else if (opcion.titulo === titulo_notificacion_embarazo) {
            if (!expresion_civil(datos_usuario.regimen_usuario) && datos_usuario.genero == "F") {
                return resultado
            }
        } 
        else if (opcion.titulo === titulo_registro_e_s_almuerzo) {
            if (expresion_adm(datos_usuario.regimen_usuario) && !datos_usuario.roles_usuario.includes(ROL_DIRECTIVO_UNIDAD) && !datos_usuario.roles_usuario.includes(ROL_ASESOR))
                return resultadoRedirect
        }
        else if (opcion.titulo === titulo_registro_marcaciones2) {
            if (expresion_adm(datos_usuario.regimen_usuario) && datos_usuario.roles_usuario.includes(ROL_ASESOR))
                return resultadoRedirect
        }
        else if (opcion.titulo === titulo_registro_proyectos_institucionales) {
            if (!(datos_usuario.roles_usuario.includes(ROL_RECTOR) || datos_usuario.roles_usuario.includes(ROL_VICERRECTOR)))
                return resultado
        }
        else if (opcion.titulo === titulo_registro_proyectos_institucionales_autoridad) {
            if (datos_usuario.roles_usuario.includes(ROL_RECTOR) || datos_usuario.roles_usuario.includes(ROL_VICERRECTOR))
                return resultado
        }
        else if (opcion.titulo === titulo_registro_proyectos_institucionales_consultor) {
            if (datos_usuario.roles_usuario.includes(ROL_RECTOR) || datos_usuario.roles_usuario.includes(ROL_VICERRECTOR))
                return resultado
        }
        else if (opcion.titulo === titulo_opcion_horas_extras) {
            if (datos_usuario.roles_usuario.includes(ROL_ENCARGADO_GPE)) {
                return resultado
            }
        }
        else {
            return resultado
        }

    }

    function condicion_mostrar_Rows(opciones: opcionesSideBar, datosUsuario: UserData) {
        var opcionMenu = <Sidebar_Principal_Row titulo_opcion_padre={opciones.titulo} subopciones={opciones} isChild={false} isSubNieto={true} />
       
        if (opciones.titulo === "Vacaciones") {
            if (opciones.rol_usuario && opciones.rol_usuario === ROL_USUARIO && !datosUsuario.soloTieneContratoESPOLTECH && !expresion_civil(datosUsuario.regimen_usuario) ){//!VerificarSoloTieneContratoRegimen(ID_REGIMEN_CONTRATO_CIVIL, datosUsuario)) {
                return opcionMenu
            }
            if (opciones.rol_usuario && opciones.rol_usuario === ROL_ADMINISTRADOR) {
                return opcionMenu
            }
        }
        else if (opciones.titulo === "Permisos / Licencias") {
            if (opciones.rol_usuario && opciones.rol_usuario === ROL_USUARIO && !datosUsuario.soloTieneContratoESPOLTECH && !expresion_civil(datosUsuario.regimen_usuario) ){//!VerificarSoloTieneContratoRegimen(ID_REGIMEN_CONTRATO_CIVIL, datosUsuario) ) {
                return opcionMenu
            }
            if (opciones.rol_usuario && opciones.rol_usuario === ROL_ADMINISTRADOR) {
                return opcionMenu
            }
        }
        //Esto es para validar la opción de Horas Extras en otros menús
        else if (opciones.titulo === "Horas Extras" && opciones.rol_usuario &&  opciones.rol_usuario !== ROL_ADMINISTRADOR) {
            
            if (expresion_adm(datosUsuario.regimen_usuario) && !datosUsuario.roles_usuario.includes(ROL_DIRECTIVO_UNIDAD) && (!datosUsuario.roles_usuario.includes(ROL_ASESOR) || datosUsuario.tieneHorarioJornadaEspecial ) ) {
                return opcionMenu;
            }
            // Si es directivo pero también tiene el rol de usuario_subrogante
            else if (datosUsuario.roles_usuario.includes(ROL_DIRECTIVO_UNIDAD) && datosUsuario.roles_usuario.includes(ROL_USUARIO_SUBROGANTE)) {
                return opcionMenu;
            }
        }
        //Esto es para validar la opción de Horas Extras en el menú de Responsable de TH
        else if (opciones.titulo === "Horas Extras" && opciones.rol_usuario && opciones.rol_usuario === ROL_ADMINISTRADOR) {
            
            if(datosUsuario.roles_usuario.includes(ROL_NOMINA_TH_HE)){
                return opcionMenu;
            }
        }

        else {
            return (opcionMenu);
        }
    }

    //Datos del usuario que se necesita
    const { periodo_planificacion_vac_activo, roles, tipo_director_unidad } = props.datos_usuario
    return (
        <div className={"sideNavPrincipalNieto"} style={function_choice_animation_style()}>
            <div className="submenuHeader" onClick={() => setsubMenuNieto(false)}>

                <div>
                    {Icono_Flecha_Regreso}
                </div>
                <div className="container_icono_padre_submenu">
                    {icono_opcion_padre}
                </div>
                <div>
                    {titulo_opcion_padre}
                </div>
            </div>
            <div className="container_titulo_submenuNieto">{titulo_opcion_submenuNieto}</div>
            {valoressubMenuNieto.map((opciones, index) => {
                return (
                    <React.Fragment key={index}>

                        {!opciones.tipo.rows ?
                            condicion_mostrar_opciones_nieto(opciones, periodo_planificacion_vac_activo, tipo_director_unidad, props.datos_usuario, titulo_opcion_padre)
                            :
                            condicion_mostrar_Rows(opciones, props.datos_usuario)
                        }
                    </React.Fragment>
                )
            })}
        </div>
    )
}
export default Sidebar_Principal_SubmenuNieto;